import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	Grid,
	Switch,
	TextField,
	withStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const IOSSwitch = withStyles((theme) => ({
	root: {
		width: 42,
		height: 26,
		padding: 0,
		margin: theme.spacing(1),
	},
	switchBase: {
		padding: 1,
		"&$checked": {
			transform: "translateX(16px)",
			color: theme.palette.common.white,
			"& + $track": {
				backgroundColor: "#52d869",
				opacity: 1,
				border: "none",
			},
		},
		"&$focusVisible $thumb": {
			color: "#52d869",
			border: "6px solid #fff",
		},
	},
	thumb: {
		width: 24,
		height: 24,
	},
	track: {
		borderRadius: 26 / 2,
		border: `1px solid ${theme.palette.grey[400]}`,
		backgroundColor: theme.palette.grey[50],
		opacity: 1,
		transition: theme.transitions.create(["background-color", "border"]),
	},
	checked: {},
	focusVisible: {},
}))(({ classes, ...props }) => {
	return (
		<Switch
			focusVisibleClassName={classes.focusVisible}
			disableRipple
			classes={{
				root: classes.root,
				switchBase: classes.switchBase,
				thumb: classes.thumb,
				track: classes.track,
				checked: classes.checked,
			}}
			{...props}
		/>
	);
});

export default function FormOnEditRole(props) {
	const {
		open,
		handleClose,
		editDataPrevilage,
		option,
		setOption,
		fetchAPI,
		handleOptionPrevilage,
	} = props;
	const { handleSubmit } = useForm();
	// const [onError, setOnError] = useState(true)
	const [state, setState] = useState({
		id: "",
		name: "",
	});

	const onSubmit = async () => {
		await fetchAPI("editPrevilage", { id: state.id, data: option });
	};

	useEffect(() => {
		if (editDataPrevilage) {
			setState({
				id: editDataPrevilage.id,
				name: editDataPrevilage.nama,
			});
			handleOptionPrevilage(editDataPrevilage.id);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [editDataPrevilage]);

	const handleChange = (event) => {
		setOption(
			option.map((item) => {
				if (item.nama === event.target.name) {
					return {
						...item,
						privilege: event.target.checked,
					};
				}
				return item;
			})
		);
	};

	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<DialogTitle id="form-dialog-title">
						Edit On Role Privilege
					</DialogTitle>
					<DialogContent>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={12}>
								<TextField
									disabled
									id="name"
									name="name"
									value={state.name}
									label="Role"
									type="string"
									fullWidth
									variant="outlined"
								/>
							</Grid>
							<Grid
								item
								xs={12}
								sm={12}
								style={{ display: "row", justifyContent: "space-between" }}
							>
								{option &&
									option.map((row) => (
										<FormControlLabel
											style={{ width: "30%" }}
											id={row.id}
											control={
												<IOSSwitch
													checked={row.privilege}
													onChange={handleChange}
													name={row.nama}
													value={row.id}
												/>
											}
											label={row.nama}
										/>
									))}
							</Grid>
						</Grid>
					</DialogContent>
					<DialogActions>
						<Button type="submit" color="primary">
							Save
						</Button>
						<Button onClick={handleClose} color="secondary">
							Cancel
						</Button>
					</DialogActions>
				</form>
			</Dialog>
		</div>
	);
}
